import { Auth } from '@jg/auth';
import Preact from 'preact';
import LoggedIn from './LoggedIn';
import LoggedOut from './LoggedOut';
import { UserContent } from '../../content/content';

interface Props {
  content: UserContent;
  analytics?: {
    track: (analyticsPayload: object) => void;
  };
  showPip: boolean;
  auth: Auth;
  handleShowModal: (showModal: boolean) => void;
}

const User: Preact.FunctionalComponent<Props> = ({
  analytics,
  auth,
  content,
  showPip,
  handleShowModal,
}) =>
  auth.isUserLoggedIn() ? (
    <LoggedIn
      analytics={analytics}
      auth={auth}
      menu={content.userMenu}
      showPip={showPip}
      handleShowModal={handleShowModal}
    />
  ) : !auth.isGuest() ? (
    <LoggedOut {...content.loggedOut} />
  ) : null;

export default User;
